module.exports = __webpack_public_path__ + "static/img/a119.6bc28ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a119.jpg
// module id = 8e2R
// module chunks = 0